export const ReturnIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.74711 13.4563C9.2994 13.4563 9.74711 13.0086 9.74711 12.4563C9.74711 11.904 9.2994 11.4563 8.74711 11.4563H3.8403L4.88026 10.4163C5.79221 9.50437 4.378 8.09015 3.46604 9.0021L0.730754 11.7374C0.341611 12.1138 0.322653 12.7823 0.718776 13.1636L3.46604 15.9109C4.378 16.8228 5.79221 15.4086 4.88026 14.4966L3.8399 13.4563H8.74711Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3072 3C14.8514 3 14.4037 3.11975 14.0087 3.34725C13.3862 3.70297 12.7632 4.05776 12.1401 4.41256C10.8927 5.12289 9.64522 5.83324 8.40209 6.55106C8.03125 6.76516 7.66916 7.09329 7.45201 7.46868C7.30367 7.72512 7.22202 8.35156 7.74545 8.75L14.3072 12.5894V18.5293C14.3072 18.5293 9.14904 15.5557 8.76517 15.3363C8.3813 15.117 7.83291 15.2376 7.48195 15.7202C7.13098 16.2028 7.40518 16.8389 7.77808 17.0473L14.0088 20.6623C14.8353 21.1384 15.7818 21.1374 16.6078 20.661L22.2123 17.4584C23.0024 17.0023 23.512 16.1207 23.513 15.2083V8.80117C23.512 7.86154 23.0258 7.02074 22.2123 6.55105L16.6057 3.34728C16.2108 3.11977 15.763 3 15.3072 3ZM21.2138 15.7255L16.3072 18.5293V12.5894L21.513 9.57808L21.513 15.2069C21.5125 15.417 21.3954 15.62 21.2138 15.7255ZM15.6078 5.08056L20.4804 7.86487L18.914 8.77097L16.9153 9.92712L15.3072 10.8574L10.134 7.86488L11.7439 6.94494L13.7548 5.79585L15.0066 5.08056C15.1894 4.97501 15.425 4.97502 15.6078 5.08056Z"
        fill="currentColor"
      />
    </svg>
  );
};
